// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iu","advertCardNum":"c-a_iv"};